import React from 'react';
import { Box, Typography } from '@mui/material';
import {
    ContractorChecklistDrawer,
    ContractorActivityDrawer,
    ContractorStageGateDrawer,
    ContractorQueryDrawer,
    ContractorMeetingDrawer,
    ContractorRecurringTaskDrawer,
} from './ContractorDrawers';
import { ContractorRiskDrawer } from './ContractorDrawers/ContractorRiskDrawer';

interface ContractorObjectDrawerProps {
    objectType: string | null;
    objectId: number | null;
    projectId?: string;
    taskId?: number | null;
    onCompleteTask?: (taskId: string) => Promise<void>;
    isAssignedToUser?: boolean;
    refetch?: () => void;
    onRefetchRequired?: (drawerName: string, refetchFn: () => void) => void;
    handleClose: () => void;
}

export const ContractorObjectDrawer: React.FC<ContractorObjectDrawerProps> = ({
    objectType,
    objectId,
    projectId,
    taskId,
    onCompleteTask,
    isAssignedToUser,
    refetch,
    onRefetchRequired,
    handleClose,
}) => {
    if (!objectType || !objectId) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <Typography>No object selected</Typography>
            </Box>
        );
    }

    switch (objectType) {
        case 'risk':
            return <ContractorRiskDrawer riskId={objectId} projectId={projectId} />;

        case 'queries':
            return <ContractorQueryDrawer queryId={objectId} />;

        case 'meeting':
            return (
                <ContractorMeetingDrawer
                    meetingId={objectId}
                    onCompleteTask={onCompleteTask}
                    isAssignedToUser={isAssignedToUser}
                    taskId={taskId ? Number(taskId) : undefined}
                    refetch={refetch}
                    onRefetchRequired={(refetchFn) => onRefetchRequired?.('meeting', refetchFn)}
                />
            );

        case 'stage_gate':
            return <ContractorStageGateDrawer stageGateId={objectId} projectId={projectId} handleClose={handleClose} />;

        case 'activity':
            return <ContractorActivityDrawer activityId={objectId} projectId={projectId} stageId={objectId} handleClose={handleClose} />;

        case 'checklist':
            return <ContractorChecklistDrawer stageId={objectId} taskId={taskId} />;

        case 'recurring_task':
            return <ContractorRecurringTaskDrawer taskId={objectId} projectId={projectId} />;

        default:
            return (
                <Box
                    height="100%"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                    gap={2}
                >
                    <Typography color="error">Unknown object type: {objectType}</Typography>
                </Box>
            );
    }
};
